import { makeStyles } from '@mui/styles';
const darkGray = '#263238';
export const useStyles = makeStyles((theme) => {
  return {
    root: {},
    clientPart: {
      marginInlineEnd: 'auto',
      marginInlineStart: theme.spacing(2),
      [theme.breakpoints.down('lg')]: {
        marginTop: theme.spacing(1),
        marginInlineStart: theme.spacing(0.5),
      },
    },
    clientTitle: {
      fontSize: 14,
      color: darkGray,
      fontWeight: 'bold',
      '& span': {
        color: '#78909c',
        marginInlineStart: theme.spacing(1),
      },
    },
    clientDesc: {
      fontSize: 14,
      color: darkGray,
      fontWeight: '400',
      marginTop: 8,
      overflowWrap: 'break-word',
    },
    accordian: {
      marginBottom: theme.spacing(2),
      boxShadow: 'none',
      border: '1px solid #cfd8dc',
      borderRadius: 4,
      minWidth: 280,
    },
    header: {
      background: '#f7f8f8',
      border: 'none !important',
      minHeight: '95px !important',
      padding: theme.spacing(1),
      cursor: 'initial !important',
      boxSizing: 'border-box',
      margin: 0,
      '& .MuiAccordionSummary-content': {
        margin: 0,
        padding: 0,
      },
    },
    logo: {
      width: 80,
      height: 80,
      objectFit: 'contain',
      background: 'white',
      padding: theme.spacing(1),
      border: `1px solid #cfd8dc`,
      borderRadius: 5,
    },
    keyTitlePart: {
      marginInlineStart: 'auto',
      marginInlineEnd: theme.spacing(2),
      [theme.breakpoints.down('lg')]: {
        marginTop: theme.spacing(2),
        marginInlineEnd: theme.spacing(0.5),
      },
    },
    viewSiteButton: {
      marginInlineEnd: theme.spacing(1),
      border: 'none',
      background: theme.palette.primary.lighter,
      '&:hover': {
        background: theme.palette.primary.light,
        border: 'none',
      },
    },
    pagination: {
      display: 'flex',
      justifyContent: 'center',
    },
    exportAll: {
      marginBottom: theme.spacing(1),
      [theme.breakpoints.down('lg')]: {
        marginTop: theme.spacing(2),
      },
    },
  };
});